import { useConfigurator } from '@/app/store/configurator/hooks/use-configurator';
import { BORDER_WIDTH, RACK_MATERIAL_COLORS } from '@/shared/constants/configurator';
import { DISPLAY_SCALE } from '@/shared/constants/editor';
import { useBlockSize } from '@/shared/hooks/use-block-size';
import clsx from 'clsx';
import { useRef } from 'react';
import { BORDER_GAP_DISTANCE, BORDER_GAP_WIDTH } from '../../constants/section.constants';
import { BorderGap } from '../border-gap/border-gap';
import styles from './section-border.module.css';
import { SectionBorderProps } from './section-border.props';

export const SectionBorder = ({ className, style, type, ...props }: SectionBorderProps) => {
	const {
		state: { material },
	} = useConfigurator();
	const wrapperRef = useRef<HTMLDivElement>(null);
	const blockSize = useBlockSize(wrapperRef);

	const gapsCount = Math.floor(blockSize.height / (BORDER_GAP_WIDTH + BORDER_GAP_DISTANCE));

	return (
		<div
			ref={wrapperRef}
			style={{
				width: BORDER_WIDTH * DISPLAY_SCALE,
				backgroundColor: RACK_MATERIAL_COLORS[material],
				...style,
			}}
			className={clsx(styles.wrapper, className)}
			{...props}
		>
			{Array.from({ length: 2 }).map((_, index) => (
				<div className={styles.gapsLine} key={index}>
					{Array.from({ length: gapsCount }).map((_, index) => (
						<BorderGap type={type} key={index} />
					))}
				</div>
			))}
		</div>
	);
};
